export class GrupoPersona {
    // que son documentos validos de identificación para las autoridades colombianas
    public static DOCUMENTO_VALIDO_COLOMBIA = 1;
    // son prospectos
    public static PROSPECTOS = 2;
    // son tipos de Id inventados para algunos productos, solo sirven en Sura
    public static INVENTADOS_SURA = 3;
    // Son id internacionales
    public static DOCUMENTOS_INTERNACIONALES = 4;
}



// WEBPACK FOOTER //
// ./src/app/contants/grupo-persona.constant.ts